import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Input, Button } from 'reactstrap';
import { } from 'react-router-dom';
import { teamActions, getCurrentTeam } from '../../../core/teams'
import { DEFAULT_SESSION_ID } from '../../../core/constants'
import { teamsReportListActions, getTeamsReportById } from '../../../core/teams-report'

import ReactGA from 'react-ga'
import { trackingActions } from '../../../core/tracking';
import { getNavigate } from '../../../navigationService';

class CreateModal extends Component {

  constructor(props) {
    super(props)

    this.state = {
      team: this.props.team ? props.team.toJS() : {},
      current_action: null,
      validation: {
        message: null,
        valid: true
      }
    }
    this.handleClick = this.handleClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.navigate = getNavigate();
  }

  componentDidMount() {
    const { team_id, team, loadTeam, loadTeamsReport } = this.props;

    loadTeam(team_id);

    if (team_id !== DEFAULT_SESSION_ID && !team.name) {
      loadTeamsReport(team_id);
    }

    this.setState({
      team: this.props.team_report.toJS(),
    });
  }

  componentDidUpdate(oldProps) {
    const { team, team_report } = this.props;
    const { current_action } = this.state;
    if (oldProps.team_report && oldProps.team_report.isNew && oldProps.team_report.isPending && !team_report.isPending) {
      this.setState({
        team: team_report.toJS(),
      });
    }

    if (oldProps.team.update_at != team.update_at) {

      if (team.error) {
        let validation = {
          message: team.error.message,
          valid: false
        }
        if (team.error.code === 'TEA0004') {
          validation = {
            message: 'There is already a team with that name.',
            valid: false
          }
        }

        this.setState({
          validation
        });
      }
      else {
        if (current_action === 'create') {
          this.setState({
            team: team_report.toJS(),
          });
          this.navigate(`/teams/${team.id}/add-member`)
        }
        else if (current_action) {
          //this.navigate(`/teams/${team.id}`);
        }
      }
    }
  }

  handleInputChange({ target }) {

    const value = target.type === 'checkbox' ? target.checked : target.value.trim();
    const name = target.name;
    const { team } = this.state;
    const _team = Object.assign({}, team, {
      [name]: value
    })

    this.setState({
      team: _team,
      validation: {
        message: null,
        valid: true
      }
    });
  }

  handleClick({ action = 'save' }) {
    //createTeam
    const { createTeam, loadTeamMembers } = this.props
    const { team } = this.state

    if (!team.name || !team.name.length) {
      this.setState({
        validation: {
          message: 'Please enter a team name.',
          valid: false
        }
      });
      return;
    }
    if (action === 'save') {
      if (team.id === DEFAULT_SESSION_ID) {
        createTeam(team);
        this.setState({
          current_action: 'create'
        });
        ReactGA.event({
          category: 'Teams',
          action: 'Creation completed'
        })
        this.props.saveTrackingEvent({ category: 'Teams', action: 'Creation completed' })
      }
    }
  }

  render() {

    const { toggleModal } = this.props;

    const { team, validation } = this.state;
    const { user } = this.props;

    if (user.checked && !user.id)
      return null;

    const msg_error = (!validation.valid) &&
      <p className="line-height-normal mb-0 p-1 text-left small text-danger">{validation.message}</p>;

    return (
      <>
        <div className="text-center">
          <h2 className="mb-4 libre-caslon-text-regular h4-md h5">Add New Team</h2>
          <form>
            <div className="form-group mb-4">
              <Input
                type="text"
                name="name"
                maxLength="30"
                onChange={this.handleInputChange}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    this.handleClick({ action: 'save' })
                  }
                }}
                defaultValue={team.name}
                className=""
                placeholder="Enter Team Name"
              />
              {msg_error}
            </div>
            <div className='justify-content-center d-flex'>
              <Button color='green-light' size='sm' onClick={(e) => { e.preventDefault(); this.handleClick({ action: 'save' }) }} className='mx-1'>
                <svg xmlns="http://www.w3.org/2000/svg" width={15} height={14} viewBox="0 0 15 14" fill='currentColor' className='mt-n1 mr-1'>
                  <path d="M13.2,4.4l-7,7c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1s-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1
                L2.2,8.3C2.2,8.3,2.1,8.2,2.1,8.1C2,8,2,8,2,7.9c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1
                c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.1L5.7,10l6.5-6.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.3,0.1,0.5,0.2
                c0.1,0.1,0.2,0.3,0.2,0.5C13.4,4.1,13.3,4.3,13.2,4.4L13.2,4.4z"/>
                </svg>
                Create
              </Button>
              <Button color="outline-green-light" size='sm' onClick={toggleModal} className='mx-1' >
                <svg xmlns="http://www.w3.org/2000/svg" width={15} height={14} viewBox="0 0 15 14" fill='currentColor' className='mt-n1 mr-1'>
                  <path d="M11.9,10.5c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.3-0.1-0.5-0.2
                L7.5,7.9L4,11.4c-0.1,0.1-0.3,0.2-0.5,0.2s-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.3,0.2-0.5L6.6,7L3.1,3.5
                C3,3.4,2.9,3.2,2.9,3.1c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2S3.9,2.5,4,2.6l3.5,3.5L11,2.6c0.1-0.1,0.3-0.2,0.5-0.2
                c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.5L8.4,7L11.9,10.5z"/>
                </svg>
                Cancel
              </Button>
            </div>
          </form>
        </div>
      </>
    );
  }
}
//export default ThinkingTalentsPage;
//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
  const team_id = DEFAULT_SESSION_ID;
  const team = getCurrentTeam(state, props);
  const team_report = getTeamsReportById(state, team_id);
  return {
    user: state.user,
    team_id,
    team,
    team_report,
    displayLoadingIndicator: (team ? team.isPending : false) || (team_report ? team_report.isPending : false) || false,
  };
};

const mapDispatchToProps = {
  createTeam: teamActions.createTeam,
  updateTeam: teamActions.updateTeam,
  loadTeam: teamActions.loadTeam,
  fetchTeamDefaultPendingFalse: teamActions.fetchTeamDefaultPendingFalse,
  loadTeamsReport: teamsReportListActions.loadTeamsReport,
  resetTeam: teamActions.resetTeam,
  saveTrackingEvent: trackingActions.saveTrackingEvent
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateModal);